export default __webpack_public_path__ + "static/media/img_team_manager.ffcef98c.png";